import moment from 'moment-timezone';
export default (date, year) => {
  if(year != null){
    return moment.utc(date).tz('Asia/Kuala_Lumpur').format('D MMM, YYYY')  
  }
  else{
    return moment.utc(date).tz('Asia/Kuala_Lumpur').format('D MMM')
  }
};
